import mongoose from 'mongoose';

import { ICreateUpdateUserResponse } from './user';

export enum ENewsStatus {
  inactive,
  active
}

export interface INews {
  newsTitleVi: string;
  newsTitleEn: string;
  newsIntroductionVi: string;
  newsIntroductionEn: string;
  newsContentVi: string;
  newsContentEn: string;
  newsCoverImg: mongoose.Types.ObjectId;
  status: ENewsStatus;
  createdBy: mongoose.Types.ObjectId;
  updatedBy: mongoose.Types.ObjectId;
}

export interface INewsAPIResponse extends Omit<INews, 'newsCoverImg' | 'createdBy' | 'updatedBy'> {
  _id: string;
  newsCoverImg: string;
  createdAt: string;
  createdBy: ICreateUpdateUserResponse | null;
  updatedAt: string;
  updatedBy: ICreateUpdateUserResponse | null;
}
